import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";

const URL_API = ApiUrl.BASE;

const AdendaContratoService = {
    async generar(data) {
        const respuesta = await ApiService(URL_API).post(`/admin/contratos/adenda`, data);
        return respuesta.data;
    },
};

export { AdendaContratoService };
